import { useEffect, useRef } from 'react';

import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';

export const useSendBuyNowPageVirtualEvent = () => {
  const eventSent = useRef(false);

  useEffect(() => {
    if (!eventSent.current) {
      sendEvent({
        event: 'pageEvent'
      });
      eventSent.current = true;
    }
  }, []);
};

export const useSendBuyNowPageVirtualErrorEvent = () => {
  useEffect(() => {
    sendEvent({
      event: 'pageEvent',
      extraFields: {
        pagename: 'error - fast checkout'
      }
    });
  }, []);
};
